var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgBook = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.2513 6.33301H23.7513C21.9297 6.33931 20.199 7.12966 19.0013 8.50217C17.8036 7.12966 16.0729 6.33931 14.2513 6.33301H4.7513C3.87685 6.33301 3.16797 7.04189 3.16797 7.91634V28.4997C3.16797 29.3741 3.87685 30.083 4.7513 30.083H13.6021C14.0175 30.0848 14.4156 30.2497 14.7105 30.5422L15.3755 31.2072C15.6704 31.4997 16.0684 31.6646 16.4838 31.6663H21.5188C21.9342 31.6646 22.3322 31.4997 22.6271 31.2072L23.2921 30.5422C23.587 30.2497 23.9851 30.0848 24.4005 30.083H33.2513C34.1258 30.083 34.8346 29.3741 34.8346 28.4997V7.91634C34.8346 7.04189 34.1258 6.33301 33.2513 6.33301ZM17.418 26.188C16.4558 25.6299 15.3636 25.335 14.2513 25.333H6.33464V9.49967H14.2513C16.0002 9.49967 17.418 10.9174 17.418 12.6663V26.188ZM23.7513 25.333H31.668V9.49967H23.7513C22.0024 9.49967 20.5846 10.9174 20.5846 12.6663V26.188C21.5468 25.6299 22.639 25.335 23.7513 25.333Z",
    fill: "black"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBook, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/book.52c4c4c9.svg";
export { ForwardRef as ReactComponent };